const _excluded = ["children", "className", "checked", "disabled", "elevated", "focused", "hovered", "radius"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'clsx';
import { AlignTarget } from "../Align";
import { PressableCore } from "./";

const PressableControl = props => {
  const getCursor = () => {
    const {
      disabled
    } = props;
    return disabled ? 'default' : 'pointer';
  };

  const getFill = () => {
    const {
      checked,
      disabled
    } = props;

    if (checked) {
      return 'primary';
    }

    return disabled ? 'disabled' : 'base';
  };

  const getKeyline = () => {
    const {
      checked
    } = props;
    const keylineColor = checked ? 'primary' : 'base';
    return {
      color: keylineColor,
      side: 'all',
      width: 1
    };
  };

  const getShadow = () => {
    const {
      disabled,
      elevated,
      focused,
      hovered
    } = props;
    return {
      base: true,
      elevated,
      focused: disabled ? false : focused,
      hovered: disabled ? false : hovered
    };
  };

  const {
    children,
    className,
    checked,
    disabled,
    elevated,
    focused,
    hovered,
    radius
  } = props,
        remaining = _objectWithoutProperties(props, _excluded);

  const classes = classNames('PressableControl', className);
  const dimensions = 14;
  return /*#__PURE__*/React.createElement(AlignTarget, {
    lineHeight: dimensions,
    nestable: true,
    strategy: "center"
  }, alignProps =>
  /*#__PURE__*/
  // $FlowFixMe - go/flowfixme122
  React.createElement(PressableCore, _extends({}, alignProps, remaining, {
    className: classes,
    cursor: getCursor(),
    fill: getFill(),
    height: dimensions // @ts-expect-error - TS2322 - Type '{ color: string; side: string; width: number; }' is not assignable to type '"none" | PressableCoreKeylineMap | undefined'.
    ,
    keyline: getKeyline(),
    overlay: disabled,
    shadow: getShadow(),
    radius: radius,
    width: dimensions
  }), children));
};

PressableControl.defaultProps = {
  checked: false,
  disabled: false,
  elevated: true,
  focused: false,
  hovered: false,
  radius: 'all'
};
export default PressableControl;